import React from 'react';

import { Container } from '../GenericError/styles';
import iconError from '../../assets/icons/error.svg';
import logo from '../../assets/icons/logo.svg';

interface State {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<unknown, State> {
  constructor(props: unknown) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  render(): React.ReactNode {
    const { hasError } = this.state;
    const { children } = this.props as React.PropsWithChildren<unknown>;

    if (!hasError) {
      return children;
    }

    return (
      <Container>
        <div>
          <img src={logo} alt="Logo icone" />
        </div>
        <span>Oops, parece que ocorreu um erro!</span>
        <img src={iconError} alt="Icone de Erro" />
        <button type="button" onClick={() => window.location.assign('/')}>
          Ir para o início
        </button>
      </Container>
    );
  }
}

export default ErrorBoundary;
